module.exports = __webpack_public_path__ + "static/images/logo_02.202506281547.png";